var render = function() {
  var _obj, _obj$1, _obj$2, _obj$3, _obj$4, _obj$5
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [
        _vm.$style.container,
        ((_obj = {}),
        (_obj[_vm.$style.mobile] = _vm.isTouchLikeDevice),
        (_obj[_vm.$style.shadow] = !_vm.noAction && !_vm.isTouchLikeDevice),
        (_obj[_vm.$style.sideBySide] = _vm.useMobileSideBySide),
        _obj)
      ],
      attrs: {
        itemscope: "",
        itemtype: "http://schema.org/Product",
        "data-sku": _vm.sku
      },
      on: {
        mouseenter: _vm.openAction,
        mouseleave: _vm.closeAction,
        click: _vm.handleCardClick
      }
    },
    [
      _vm._t("default"),
      _vm._v(" "),
      _vm.isExclusive && !_vm.hideExclusiveIcon
        ? _c(
            "div",
            { class: _vm.$style.exclusive },
            [
              _c("NsIcon", {
                class: _vm.$style.exclusiveIcon,
                attrs: {
                  title: _vm.showExclusiveOfferLabel
                    ? ""
                    : _vm.translations.exclusiveOfferTitle,
                  "icon-name": "icon-exclusive-offer",
                  size: "custom"
                }
              }),
              _vm._v(" "),
              _c(
                "span",
                {
                  class: [
                    _vm.$style.exclusiveLabel,
                    ((_obj$1 = {}),
                    (_obj$1[
                      _vm.$style.hideOnMobile
                    ] = !_vm.showExclusiveOfferLabel),
                    _obj$1)
                  ]
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.translations.exclusiveOfferTitle) +
                      "\n    "
                  )
                ]
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isSale && _vm.salesLabel
        ? _c("div", { class: _vm.$style.salesLabel }, [
            _vm._v("\n    " + _vm._s(_vm.salesLabel) + "\n  ")
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.isBaseSku && !_vm.hideFavorites
        ? _c(
            "div",
            {
              class: _vm.$style.favorite,
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  return _vm.handleFavoriteClick($event)
                }
              }
            },
            [
              _c("NsIcon", {
                class: [
                  _vm.$style.favoriteIcon,
                  ((_obj$2 = {}),
                  (_obj$2[_vm.$style.favorited] = _vm.isFavorite),
                  _obj$2)
                ],
                attrs: {
                  title: _vm.translations.addToFavorites,
                  role: "checkbox",
                  "aria-checked": _vm.isFavorite,
                  "icon-name": _vm.isFavorite
                    ? "icon-favorite-heart-hollow"
                    : "icon-favorite-heart"
                }
              }),
              _vm._v(" "),
              _c("NsIcon", {
                class: [
                  _vm.$style.favoriteIconHover,
                  ((_obj$3 = {}),
                  (_obj$3[_vm.$style.favorited] = _vm.isFavorite),
                  _obj$3)
                ],
                attrs: { "icon-name": "icon-favorite-heart-hollow" }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { class: _vm.$style.imageWrapper },
        [
          _c("NsImage", {
            class: _vm.$style.image,
            attrs: {
              src: _vm.image.src,
              alt: _vm.image.alt,
              "fallback-src": _vm.imageFallbackSrc,
              "maintain-ratio": "1x1",
              "image-fit": "contain",
              "size-lock": "2",
              itemprop: "image"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          class: [
            _vm.$style.mainContent,
            ((_obj$4 = {}),
            (_obj$4[_vm.$style.hasExclusiveOffer] =
              _vm.showExclusiveOfferMessage),
            _obj$4)
          ]
        },
        [
          _c("div", {
            class: _vm.$style.title,
            attrs: { itemprop: "name" },
            domProps: { innerHTML: _vm._s(_vm.title) }
          }),
          _vm._v(" "),
          _vm.showSkuPrices
            ? _c("NsProductSkuPoints", {
                class: _vm.$style.skuPoints,
                attrs: {
                  forcesv: _vm.forcesv,
                  "hide-sku": _vm.hideSku || _vm.noAction,
                  "is-distributor": _vm.isDistributor,
                  points: _vm.points,
                  sku: _vm.sku,
                  translations: _vm.translations,
                  "hide-before": _vm.useMobileSideBySide,
                  "use-new-line": _vm.useMobileSideBySide
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.showPrices
            ? _c("NsProductPrice", {
                class: _vm.$style.price,
                attrs: {
                  "adr-only": _vm.showAdrOnly,
                  "adr-price": _vm.adrPrice,
                  "adr-price-label": _vm.translations.adrPriceLabel,
                  "adr-price-type": _vm.adrPriceType,
                  "is-base-sku": _vm.isBaseSku,
                  "min-price": _vm.minPrice,
                  "max-price": _vm.maxPrice,
                  "original-price": _vm.originalPrice,
                  "original-price-label": _vm.originalPriceLabel,
                  "original-price-type": _vm.originalPriceType,
                  price: _vm.price,
                  "price-label": _vm.priceLabel,
                  "price-type": _vm.priceType,
                  "show-labels": _vm.showPriceLabels,
                  "show-original-crossed-out": _vm.showOriginalCrossedOut,
                  "show-adr-price": _vm.showAdrPrice,
                  "hide-adr-override": !_vm.showAdrOnly
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.showVariantSelector && !_vm.noAction
            ? _c("NsProductVariantSelector", {
                class: _vm.$style.variantSelector,
                attrs: {
                  placeholder: _vm.translations.variantDropdownPlaceholder,
                  "selected-sku": _vm.isBaseSku ? "" : _vm.sku,
                  disabled: _vm.disabled,
                  "variant-skus": _vm.variantSkus,
                  variants: _vm.variants,
                  size: _vm.useMobileSideBySide ? "small" : undefined
                },
                on: { select: _vm.handleSelectVariant }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          class: [
            _vm.$style.action,
            ((_obj$5 = {}),
            (_obj$5[_vm.$style.static] = _vm.isTouchLikeDevice),
            (_obj$5[_vm.$style.shadowAction] = !_vm.isTouchLikeDevice),
            _obj$5)
          ]
        },
        [
          !_vm.noAction
            ? _c(
                "NsAnimateHeight",
                {
                  attrs: {
                    open:
                      _vm.actionOpened ||
                      _vm.isTouchLikeDevice ||
                      _vm.showAction
                  }
                },
                [
                  _c("NsProductCardAction", {
                    attrs: {
                      "disable-add-to-adr": _vm.disableAddToAdr,
                      "disable-add-to-cart": _vm.disableAddToCart,
                      "disable-quantity-selector": _vm.disableQuantitySelector,
                      "exclusive-offer-message": _vm.exclusiveOfferMessage,
                      "max-quantity": _vm.maxQuantity,
                      "mobile-side-by-side": _vm.useMobileSideBySide,
                      quantity: _vm.quantity,
                      "show-exclusive-offer-message":
                        _vm.showExclusiveOfferMessage,
                      "status-message": _vm.statusMessage,
                      "status-message-key": _vm.statusMessageKey,
                      translations: _vm.translations
                    },
                    on: {
                      "quantity-select": _vm.handleQuantitySelect,
                      "add-to-cart": _vm.handleAddToCart,
                      "add-to-adr": _vm.handleAddToAdr,
                      "go-to-details": _vm.handleCardClick
                    }
                  })
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }